import React, { useCallback, useEffect } from 'react';
import { Modal, ModalProps } from '@material-ui/core';
import './styles.scss';

const AloModal = ({
  children,
  closeElement,
  disableBackdropClick = false,
  MUIModalProps,
  noPadding = false,
  open = false,
  onClose,
  onOpen,
  showCloseButton = true,
  trigger = null,
  wrapperClass = '',
  containerClass = '',
}: AloModalOptions) => {
  const [mounted, setMounted] = React.useState(open);

  React.useEffect(() => {
    setMounted(open);
  }, [open]);

  const closeModal = useCallback(() => {
    setMounted(false);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  const openModal = () => {
    setMounted(true);
    if (onOpen) {
      onOpen();
    }
  };

  // Close modal on closeElement selectors click.
  useEffect(() => {
    if (closeElement && closeElement.length !== 0) {
      const additionalCloseButtons = document.querySelectorAll(closeElement);
      additionalCloseButtons.forEach((button) => button.addEventListener('click', closeModal));
      return () => {
        additionalCloseButtons?.forEach((button) => button.removeEventListener('click', closeModal));
      };
    }
  }, [closeModal, closeElement, mounted]);

  return (
    <>
      {trigger && (
        <div className="alomodal-trigger" onClick={openModal}>
          {trigger}
        </div>
      )}
      <Modal
        onBackdropClick={() => {
          if (!disableBackdropClick) {
            closeModal();
          } else {
            return;
          }
        }}
        className={`alo-modal-container ${containerClass}`}
        open={mounted}
        {...MUIModalProps}
        disableEnforceFocus
      >
        <div className="alo-modal-scroller">
          {!disableBackdropClick && <div className="alo-modal-backdrop" onClick={() => closeModal()}></div>}
          <div className={`alo-modal ${wrapperClass} ${noPadding ? 'alo-modal--no-padding' : ''}`}>
            {showCloseButton ? (
              <div className="alo-modal-close-container">
                <button className="alo-modal-close-icon" onClick={closeModal} />
              </div>
            ) : null}
            {children}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AloModal;

interface AloModalOptions {
  children: React.ReactNode;
  closeElement?: string; // Additional element selector that closes modal
  disableBackdropClick?: boolean;
  MUIModalProps?: Omit<ModalProps, 'open' | 'children'>;
  noPadding?: boolean;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  showCloseButton?: boolean;
  trigger?: React.ReactNode;
  wrapperClass?: string;
  containerClass?: string;
}
